import styled from 'styled-components'
import { colors, fieldLabel, fontScope, radius } from '../tokens'

export const Card = styled.div`
  ${fontScope}
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  min-width: 0;
  min-height: 125.6px;
  box-sizing: border-box;
  padding: 21px 17px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.card};
  background: ${colors.white};
`

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: ${radius.kpiIcon};
  background: ${colors.kpiIconBg};
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  min-width: 0;
`

export const Label = styled.p`
  ${fieldLabel}
  margin: 0;
  white-space: nowrap;
`

export const Value = styled.p<{ $tone: 'default' | 'positive', $compact: boolean }>`
  margin: 0;
  padding-top: 8px;
  font-size: ${({ $compact }) => ($compact ? '24px' : '32px')};
  font-weight: 800;
  line-height: ${({ $compact }) => ($compact ? '30px' : '36px')};
  letter-spacing: -0.6px;
  color: ${({ $tone }) => ($tone === 'positive' ? colors.positive : colors.ink950)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Caption = styled.p`
  margin: 0;
  padding-top: 4px;
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
  color: ${colors.ink400};
`
